module.exports = __webpack_public_path__ + "img/icon-map-implantation-03.63c26a4f.svg";